<script>
import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],    
 data() {
  return { 
   title: "CRM",
   text: "CRM",
   toast: useToast(),
   total: 0,
   data: [],
   current_page: 1,
   page_size: 25,
   searchText: '', 
   columns: [
    {
     title: 'S.No',
     dataIndex: 'SNo',
     key: 'SNo',
    },
    {
     title: 'Industry Name',
     dataIndex: 'IndustryName',
     key: 'IndustryName',
    },
    {
     title: 'Actions',
     key: 'action',
    },
   ],
   rowSelection: null,
  };
 },

 computed: {
  text1(){
   return `Industries (${this.total})`; 
  },
  filteredData() {
   if (!this.searchText) return this.data;
   const search = this.searchText.toLowerCase();
   return this.data.filter(item => item.name?.toLowerCase().includes(search));
  },
 },

 mounted() {
  this.industries();
 }, 

 methods: {
  async industries(){
   this.setLoading(true);
   try{
    const response = await axios.get(`/industries`);
    this.data = response.data.data;
    this.total = this.data.length;
   }catch(error){
    this.toast.error(error.message);
   }finally{
    this.setLoading(false);
   }
  },
  handleTableChange(pagination){
   this.current_page = pagination.current;
   this.page_size = pagination.pageSize;
  }
 },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>

<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
<div class="mb-2">
<a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#industry_modal" class="btn btn-primary d-flex align-items-center" @click="$refs.industryModal.industry();"><i class="ti ti-circle-plus me-2"></i>Add New</a>
</div>

</div>
</div>
<!-- /Breadcrumb -->

<div class="card">
<div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
<h5>Industries List</h5>
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
<div class="">
  <a-input v-model:value="searchText" placeholder="Search industry name..." allow-clear style="width: 300px;"/>
</div>

</div>
</div>
<div class="card-body p-0">
<div class="custom-datatable-filter table-responsive">

<a-table v-if="filteredData.length" class="table datatable thead-light" :columns="columns" :data-source="filteredData"
  :row-selection="rowSelection" :pagination="{ pageSize: page_size, current: current_page }" @change="handleTableChange">
  <template #bodyCell="{ column, record, index }">
    <template v-if="column.key === 'SNo'"> {{ index + 1 + (current_page - 1) * page_size }}. </template>   
    <template v-if="column.key === 'IndustryName'">
      <h6 class="fs-14 fw-medium">
        <router-link to="#">{{ record.name }}</router-link>
      </h6>
    </template>
    <template v-if="column.key === 'action'">
      <div class="action-icon d-inline-flex">
        <a href="javascript:void(0);" class="me-2" data-bs-toggle="modal" data-bs-target="#industry_modal" @click="$refs.industryModal.industry(record)">
          <i class="ti ti-edit"></i>
        </a>
        <a href="javascript:void(0);" class="text-danger" data-bs-toggle="modal" data-bs-target="#delete_modal" @click="$refs.industryModal.industry(record)">
          <i class="ti ti-trash"></i>
        </a>
      </div>
    </template>
  </template>
</a-table>

 <div v-else class="p-3 text-center text-muted"> No records found. </div>

</div>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->

<industry-modal ref="industryModal" @updated="industries"></industry-modal>
</template>